import { useSelector } from 'react-redux';

import { getCurrentContractId } from '@app/reducers/current-contract';
import useAgreement from '@app/hooks/use-agreement';

const useCurrentAgreement = (): Oneflow.Agreement => {
  const agreementId = useSelector(getCurrentContractId) as number;
  return useAgreement(agreementId);
};

export default useCurrentAgreement;
